// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__16ky3","actionsCol":"EnrolledClinics_actionsCol__3zIUx"};